import { Typography, Box } from '@mui/material';
import React, { type ElementType, useEffect, useState } from 'react';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import useRef from '../../helpers/hooks/useRefWrapper';
import { useStyles } from './LinkList.styles';
import NoStyleLink from '../ButtonsLinks/NoStyleLink';
import AnalyticsWrappedComponent from '../Analytics/AnalyticsWrappedComponent';
import { type Link } from '../../types/link';

interface LinkListProps {
  title: string;
  links: Link[];
  headerElement?: ElementType;
  canViewMore?: boolean;
}

const LinkList = ({
  title,
  links,
  headerElement = 'h2',
  canViewMore = true,
}: LinkListProps) => {
  const [isViewingMore, setIsViewingMore] = useState(false);
  const [linksOverflowContainer, setLinksOverflowContainer] = useState(false);
  const classes = useStyles({ canViewMore, isViewingMore });
  const containerRef = useRef(null);

  useEffect(() => {
    setLinksOverflowContainer(containerRef.current?.scrollHeight > 208);
  }, []);

  return (
    <Box>
      <Typography data-test-id="title" variant="h2" component={headerElement}>
        {title}
      </Typography>
      <div className={classes.linkList} ref={containerRef}>
        {links.map((link) => (
          <Box key={link.label} className={classes.linkWrapper}>
            <AnalyticsWrappedComponent
              componentType={NoStyleLink}
              eventText={`Clicked ${title}`}
              eventLabel={link.label
                ?.split(' ')

                ?.slice(0, title?.split(' ')?.length - 1)
                ?.join(' ')}
              href={link.href}
            >
              <Typography variant="h3" className={classes.label}>
                <span suppressHydrationWarning>{link.label}</span>
              </Typography>
              {link.subLabel && (
                <Typography variant="h4" className={classes.subLabel}>
                  <span suppressHydrationWarning>{link.subLabel}</span>
                </Typography>
              )}
            </AnalyticsWrappedComponent>
          </Box>
        ))}
      </div>
      {canViewMore && linksOverflowContainer && (
        <Typography
          data-test-id="view-more-less"
          component="h3"
          className={classes.viewMore}
          onClick={() => setIsViewingMore(!isViewingMore)}
        >
          {isViewingMore ? 'View Less' : 'View More'}
          {isViewingMore ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </Typography>
      )}
    </Box>
  );
};

export default LinkList;
